import {Component, DestroyRef, ElementRef, inject, input, output, ViewChild} from '@angular/core';
import {SharedModule} from '../../../core/modules/shared.module';
import {fromEvent as observableFromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {fuseAnimations} from '../../../core/animations';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatSidenav} from '@angular/material/sidenav';

@Component({
  selector: 'pages-container',
  templateUrl: './pages-container.component.html',
  styleUrls: ['./pages-container.component.scss'],
  standalone: true,
  animations: fuseAnimations,
  imports: [SharedModule]
})

export class PagesContainerComponent {
  @ViewChild('sidenav') sidenav?: MatSidenav;

  title = input.required<string>();
  subtitle = input<string>('');
  icon = input<string>('list');
  showSearch = input<boolean>(false);
  showFilter = input<boolean>(false);

  onSearchSent = output<string>();

  private destroyRef = inject(DestroyRef);
  private isSearchInitialized = false;
  @ViewChild('filter') set filter(content: ElementRef) {
    if (content && !this.isSearchInitialized) {
      this.setupSearch(content);
      this.isSearchInitialized = true;
    }
  }

  ngOnInit() {

  }

  private setupSearch(elementRef: ElementRef) {
    observableFromEvent(elementRef.nativeElement, 'keyup')
      .pipe(
        debounceTime(800),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        const value = elementRef.nativeElement.value;
        if (value && value.trim() !== '' && value !== 'null') {
          this.onSearchSent.emit(value);
        } else {
          this.onSearchSent.emit('');
        }
      });
  }
}
